import { useEffect, useState } from 'react';
import { Approval, ApprovalQuery, reportReviewService } from '../../services/reportReview.service';

interface ApprovalState {
  approval: Approval | null;
  /** 조회가 끝났는가(성공·실패 무관). PDF 로딩 신호에 묶는다 */
  settled: boolean;
}

/** 보고서 결재란 조회. query 가 null 이면(기간·회사 미선택) 호출하지 않는다 */
export function useApproval(query: ApprovalQuery | null): ApprovalState {
  const [state, setState] = useState<ApprovalState>({ approval: null, settled: false });
  // 객체 참조가 매 렌더 바뀌어도 같은 조회는 한 번만 한다
  const key = query ? JSON.stringify(query) : null;

  useEffect(() => {
    if (!key) {
      setState({ approval: null, settled: false });
      return;
    }
    let stale = false;
    setState({ approval: null, settled: false });
    reportReviewService
      .getApproval(JSON.parse(key) as ApprovalQuery)
      .then((approval) => {
        if (!stale) setState({ approval, settled: true });
      })
      .catch(() => {
        // 결재란이 없어도 보고서는 보여야 한다 — 숨김 처리
        if (!stale) setState({ approval: null, settled: true });
      });
    return () => {
      stale = true;
    };
  }, [key]);

  return state;
}
